import "core-js/modules/es.regexp.exec.js";
import f2eJson from '../../f2eci.json';
export var isProd = process.env.DEPLOY_ENV === 'production' || /product|ppe/.test(f2eJson.env);
function getDetailUrl(id) {
  var isDp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (isProd) {
    return isDp ? "https://h5.dianping.com/app/myshow/#/detail/".concat(id, "?_blank=true") : "https://show.maoyan.com/qqw/#/detail/".concat(id);
  } else {
    return isDp ? "https://h5.51ping.com/app/myshow/#/detail/".concat(id, "?_blank=true") : "https://show.test.maoyan.com/qqw/#/detail/".concat(id);
  }
}
var openApp = {
  openWeb: function openWeb(args) {
    var appType = args.appType,
      pId = args.pId;
    var url = getDetailUrl(pId, appType === 'dianping');
    if (appType === 'meituan') {
      location.href = "https://m.dianping.com/cube/evoke/meituan.html?url=".concat(encodeURIComponent("imeituan://www.meituan.com/web?url=".concat(encodeURIComponent(url))));
    } else if (appType === 'dianping') {
      location.href = "https://m.dianping.com/cube/evoke/dianping.html?url=".concat(encodeURIComponent("dianping://web?url=".concat(encodeURIComponent(url))));
    } else if (appType === 'maoyan') {
      location.href = "https://m.dianping.com/cube/evoke/maoyan.html?url=".concat(encodeURIComponent("meituanmovie://www.meituan.com/web?url=".concat(encodeURIComponent(url))));
    }
  }
};
export default openApp;